import { Phone } from "lucide-react";
import { cn } from "@/lib/utils";
import { PHONE_DISPLAY as PHONE_NUMBER, PHONE_TEL_HREF as PHONE_HREF } from "@/lib/business";

export { PHONE_NUMBER, PHONE_HREF };

type PhoneButtonVariant = "inline" | "pill" | "pill-outline" | "full-width";

interface PhoneButtonProps {
  variant?: PhoneButtonVariant;
  className?: string;
  /** Show the number text (default true) */
  showNumber?: boolean;
  /** Override display label */
  label?: string;
}

const variantClasses: Record<PhoneButtonVariant, string> = {
  inline:
    "flex items-center gap-2 text-base font-medium text-primary font-semibold",
  pill:
    "cta-hover inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-8 py-3 rounded-full font-display uppercase tracking-[0.15em] text-sm transition-all",
  "pill-outline":
    "cta-hover-outline inline-flex items-center justify-center gap-2 border border-foreground/30 text-foreground px-10 py-3 rounded-full font-display uppercase tracking-[0.2em] text-sm transition-all",
  "full-width":
    "cta-hover-outline w-full flex items-center justify-center gap-2 border border-border text-foreground px-6 py-3 rounded-full font-display uppercase tracking-[0.1em] text-sm transition-all",
};

export default function PhoneButton({
  variant = "inline",
  className,
  showNumber = true,
  label,
}: PhoneButtonProps) {
  const displayText = label ?? (showNumber ? PHONE_NUMBER : "Call Now");

  return (
    <a href={PHONE_HREF} className={cn("group", variantClasses[variant], className)}>
      <Phone className="h-4 w-4 phone-ring-hover" />
      <span>{displayText}</span>
    </a>
  );
}
